import React from 'react';
import './styles.scss';

const StyledLink = ({ variant = 'default', children, className, ...props }) => {
  const linkClass = `custom-link variant-${variant} ${className}`;
  return (
    <a className={linkClass} {...props}>
      {children}
    </a>
  );
};

export default StyledLink;
